module.exports = __webpack_public_path__ + "img/chaojidianzhang-product.ef83f8a9.jpg";